var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
}; /* eslint-disable react/jsx-indent */ /* eslint-disable react/jsx-indent-props */
import { Typography } from '@arco-design/web-react';
import cs from 'classnames';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { CollapseIcon, MoreIcon } from '../svg';
var lineHeight = 24;
export function useInfo(_a) {
  var _b;
  var cardProps = _a.cardProps,
    prefixCls = _a.prefixCls;
  var infoMode = cardProps.infoMode,
    children = cardProps.children,
    time = cardProps.time,
    title = cardProps.title,
    subtitle = cardProps.subtitle;
  var isInfoMode = infoMode && typeof children === 'string' && (typeof time === 'string' || typeof time === 'undefined');
  var infoModeConfig = typeof infoMode === 'object' ? infoMode : null;
  var timePosition = infoModeConfig ? (_b = infoModeConfig.timePosition) !== null && _b !== void 0 ? _b : 'auto' : 'auto';
  var _c = __read(useState(true), 2),
    expanded = _c[0],
    setExpanded = _c[1];
  var _d = __read(useState(false), 2),
    hideCollapse = _d[0],
    setHideCollapse = _d[1];
  var expandRef = useRef();
  var timeRef = useRef();
  var expandRows = useMemo(function () {
    var rows = 5;
    if (title !== undefined) rows--;
    if (subtitle !== undefined) rows--;
    return rows;
  }, [title, subtitle]);
  useEffect(function () {
    if (!expandRef.current) return;
    requestAnimationFrame(function () {
      var dom = expandRef.current;
      var height = dom.clientHeight;
      setHideCollapse(height <= lineHeight * expandRows);
    });
  }, [children, time, title, subtitle, expandRows, expanded]);
  var element = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-content"),
    ref: expandRef
  }, /*#__PURE__*/React.createElement(Typography.Paragraph, {
    ellipsis: {
      rows: expandRows,
      suffix: timePosition === 'auto' ? /*#__PURE__*/React.createElement("span", {
        className: cs("".concat(prefixCls, "-content-time")),
        ref: timeRef,
        style: {
          whiteSpace: expanded ? 'pre' : undefined
        }
      }, time) : undefined,
      expandable: true,
      expandNodes: [null, null],
      expanded: expanded
    },
    style: {
      lineHeight: "".concat(lineHeight, "px")
    }
  }, children, timePosition === 'follow' && /*#__PURE__*/React.createElement("span", {
    className: cs("".concat(prefixCls, "-content-time")),
    ref: timeRef
  }, time))), timePosition === 'line' && /*#__PURE__*/React.createElement("span", {
    className: cs("".concat(prefixCls, "-content-time")),
    ref: timeRef
  }, time), (!hideCollapse || !expanded) && /*#__PURE__*/React.createElement("div", {
    className: cs("".concat(prefixCls, "-content-expand"), "".concat(prefixCls, "-content-expand-").concat(expanded ? 'collapse' : 'expand'))
  }, expanded ? /*#__PURE__*/React.createElement(CollapseIcon, {
    onClick: function onClick() {
      return setExpanded(false);
    }
  }) : /*#__PURE__*/React.createElement(MoreIcon, {
    onClick: function onClick() {
      return setExpanded(true);
    }
  })));
  return {
    isInfoMode: isInfoMode,
    timePosition: timePosition,
    element: element
  };
}